<template>
  <div class="progress-bar">
    <div class="progress-bar-inner" :style="styles"></div>
    <div
      v-show="!isFinish"
      class="progress-bar-inner-next"
      :style="styles"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: String,
      default: '0%',
    },
    isFinish: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      return {
        '--progress': this.progress,
      }
    },
  },
}
</script>

<style scoped>
.progress-bar {
  position: relative;
  top: 15px;
  width: 40%;
  height: 27px;
  background: #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  border-radius: 90px;
}
.progress-bar-inner {
  position: relative;
  --progress: 0%;
  width: calc(var(--progress) - 6px);
  height: 23px;
  top: 2px;
  left: 3px;
  background: #ffa4a4;
  z-index: 1;
  border-radius: 90px;
}
.progress-bar-inner-next {
  --progress: 0%;
  position: absolute;
  width: calc(var(--progress) + 11px);
  height: 23px;
  top: 2px;
  left: 3px;
  background: #ffd5d5;
  border-radius: 90px;
}
</style>
